import { z } from 'zod';

export const productImportSourceSchema = z.enum(['Poizon', 'VK']);

export type ProductImportSourceSchema = z.infer<typeof productImportSourceSchema>;
